<template>
  <div>
    <v-content>
      <v-layout row wrap align-start>
        <v-flex xs12 md12>
          <h1 class="content-title">Contact</h1>
          <h2 class="content-sub-title">Spice Money</h2>

          <h3 class="mb-4">If you prefer a more tangible form of communication we're here:</h3>
        </v-flex>

        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="sameHeight">
          <div style="clear:both"></div>
          <div class="leadership-name">Corporate Office</div>
          <div class="blue-bar"></div>
          <ul class="leadership-designation">
            <li>Spice Digital Limited</li>
            <li>Spice Global Knowledge Park,</li>
            <li>19A &19B, Sector-125, Noida-201301,</li>
            <li>Uttar Pradesh.</li>
            <li>
              <a href="tel:01203355131">0120-3355 131</a>
            </li>
          </ul>
          <a class="red-button bottomButton" href="tel:01203355131">Call Us</a>
          </div>
        </v-flex>

        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="sameHeight">
          <div style="clear:both"></div>
          <div class="leadership-name">For any Queries or Complaints</div>
          <div class="blue-bar"></div>
          <ul class="leadership-designation">
            <li>Call at +91 120 3986786, +91 120 5077786</li>
            <li>(Between 7AM to 11PM, all days)</li>
            <li>
              <a href="mailto:customercare@spicemoney.com">customercare@spicemoney.com</a>
            </li>
          </ul>
          <a class="red-button bottomButton" href="mailto:customercare@spicemoney.com ">Email Us</a>
          </div>
        </v-flex>
        <v-flex xs12 sm4 class="px-4 mb-5 learship-container">
          <div class="sameHeight">
          <div style="clear:both"></div>
          <div class="leadership-name">For any Queries or Complaints related to money transfer using PPI</div>
          <div class="blue-bar"></div>
          <ul class="leadership-designation">
            <li>Call at +91 120 3986786, +91 120 5077786</li>
            <li>(Between 7AM to 11PM, all days)</li>
            <li>
              <a href="mailto:ppicare@spicemoney.com">ppicare@spicemoney.com</a>
            </li>
          </ul>
          <a class="red-button bottomButton" href="mailto:ppicare@spicemoney.com ">Email Us</a>
          </div>
        </v-flex>

        <v-flex>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.8931000370144!2d77.32777531455751!3d28.542932694882467!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5d52ffff50b%3A0xe6534d32446bb551!2sSpice+Digital+Limited!5e0!3m2!1sen!2sin!4v1539853780181"
            width="100%"
            height="300"
            frameborder="0"
            style="border:0"
            allowfullscreen
          ></iframe>
        </v-flex>
      </v-layout>
    </v-content>
  </div>
</template>

<style scoped>
.sameHeight{
  height:443px;
  position:relative;
}

.bottomButton{
  position:absolute;
  bottom:0px;
}
h3 {
  font-weight: normal;
  font-size: 18px;
  font-style: italic;
  padding-bottom: 20px;
}
.content-title {
  color: #ed1c24;
  font-size: 24px;
  font-weight: normal;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}
.content-sub-title {
  font-size: 42px;
  line-height: 42px;
  text-transform: uppercase;
  color: #293896;
  margin-bottom: 30px;
}
.cursorpointer {
  cursor: pointer;
}
.content-image {
  cursor: crosshair;
}
.box-shadow {
  box-shadow: 0 0 30px #e3e3e3;
  background: #fff;
  padding: 40px 48px;
}
.leadership-img {
  position: relative;
  float: left;
}
.leadership-img img {
  position: relative;
  z-index: 3;
  max-width: 100%;
  float: left;
}
.blue-bar {
  width: 100px;
  height: 3px;
  background: #ed1c24;
  margin: 10px 0;
}
.bg-circle {
  position: absolute;
  border-radius: 50%;
  width: 100%;
  height: auto;
  padding-top: 100%;
  border: 2px dashed #a7a8aa;
  filter: alpha(opacity=60);
  filter: alpha(opacity=60);
  opacity: 0.6;
  z-index: 3;
  bottom: 10px;
  right: 10px;
}
.leadership-name {
  color: #2a3997;
  font-size: 30px;

  padding-top: 25px;
}
.leadership-designation {
  color: #242424;
  font-size: 20px;
  font-weight: 300;
  list-style: none;
  padding: 0;
  min-height: 150px;
}
.grey-circle {
  position: absolute;
  bottom: 0;
  border-radius: 50%;
  width: 100%;
  height: auto;
  padding-top: 100%;
  background-color: #ededed;
}
.learship-container {
  transition: all ease-in-out 0.5s;
}
.learship-container:hover {
  transform: scale(1.05, 1.05);
}
.red-button {
  margin-top: 30px;
  height: 80px;
  line-height: 80px;
  text-decoration: none;
  padding: 0 50px;
  border-radius: 3px;
  color: #fff;
  background: #ec1c25;
  display: inline-block;
  text-transform: uppercase;
  font-size: 30px;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.5);
}
ul {
  padding-top: 10px;
}
a {
  text-decoration: none;
}
@media only screen and (max-width: 768px) {
  .content-title {
    font-size: 14px;
  }
  .content-sub-title {
    font-size: 16px;
    line-height: 16px;
  }

  h3 {
    font-size: 14px;
  }
  .leadership-name {
    font-size: 16px;
    padding-top: 25px;
  }
  .leadership-designation {
    font-size: 14px;
    min-height: inherit;
  }
  .red-button {
    margin-top: 20px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
  }
  .sameHeight {
    height: 230px;}
}
</style>

</style>

<script>
import Contact from "./contact.ts";
export default Contact;
</script>